const DEFAULT_GOOGLE_TAG_ID = `G-6JED7776FC`

const getGoogleTagId = () => {
  return (
    process.env.GATSBY_GOOGLE_TAG_ID ||
    process.env.GATSBY_GA_MEASUREMENT_ID ||
    DEFAULT_GOOGLE_TAG_ID
  )
}

const getPagePath = location => {
  if (!location) {
    return `/`
  }

  return `${location.pathname || `/`}${location.search || ``}${location.hash || ``}`
}

module.exports = {
  DEFAULT_GOOGLE_TAG_ID,
  getGoogleTagId,
  getPagePath,
}
